



















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import { mapGetters, mapActions } from 'vuex'
import {checkPasswordValidate} from '../services/Validate'
import _ from 'lodash'

@Component
export default class ValidatePassword extends Vue {
  @Prop() public password!: string

  @Prop() public onShow!: boolean
  private validateLists: Array<{
    condition: string
    text: string
    correct: boolean,
  }> = [
    { condition: 'lowerChar', text: 'One lowercase character', correct: false },
    { condition: 'upperChar', text: 'One uppercase character', correct: false },
    { condition: 'numberChar', text: 'One number', correct: false },
    { condition: 'specialChar', text: 'One special character', correct: false },
    { condition: 'eighthChar', text: '8 character minimum', correct: false },
  ]

  @Watch('password')
  private checkValidate() {
    const listOfValid = checkPasswordValidate(this.password)
    this.validateLists.map((list) => {
      if (listOfValid.includes(list.condition)) {
        list.correct = true
      } else {
        list.correct = false
      }
      return list
    })
    const isAllValid = _.every(this.validateLists, ['correct', true])
    this.$emit('update:isValid', isAllValid)
  }
}
